<div class="sunleon-container-parametre">
    <div class="container">
      <div class="d-flex justify-content-end mb-3">
        <!-- Bouton pour ouvrir la modal d'ajout -->
        <button class="btn btn-primary" (click)="openAddModal()">
          <i class="bi bi-plus-circle"></i> Ajouter un utilisateur
        </button>
      </div>
  
      <div class="table-responsive w-100">
        <table *ngIf="utilisateurs$ | async as utilisateurs" class="table table-bordered table-striped">
          <thead class="thead-dark sticky-top">
            <tr>
              <th scope="col">Nom</th>
              <th scope="col">Prénom</th>
              <th scope="col">Email</th>
              <th scope="col">Administrateur</th>
              <th scope="col"></th>
              <!--<th scope="col"></th>-->
            </tr>  
          </thead>
          <tbody>
            <tr *ngFor="let utilisateur of utilisateurs; let i = index" [ngClass]="{'selected-row': i === selectedRowIndex}" (click)="handleRowClick(i)">
              <td>{{ utilisateur.nom }}</td>
              <td>{{ utilisateur.prenom }}</td>
              <td>{{ utilisateur.email }}</td>
              <td>
                <i class="bi" [ngClass]="utilisateur.admin ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'"></i>
              </td>
              <td>
                <i role="button" class="bi bi-pencil-square" (click)="openEditionModal(utilisateur)"></i>
              </td>
              <td>
                <i role="button" class="bi bi-trash" (click)="openDeleteModal(utilisateur)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  